/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { isEmpty } from 'lodash';

import { LogoConfig, Permissions, SettingsService } from '@ithinkdt/shared/browser';
import { COMMON_COMFIG } from '@ithinkdt/shared/utils';

import { API } from './fetch/api/api';
import { AuthFetchService } from './fetch/service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HandleLoginService {
  // æéä¿¡æ¯
  private permissionsData: Permissions[] = [];
  private modelIds: string[] = [];
  // èåä¿¡æ¯
  private menuData;
  pagesConfig: any;
  logoConfig: LogoConfig = {};
  isGetUserReady = false;
  isGetMenuReady = false;

  constructor(private settingsSrv: SettingsService, private router: Router, private authFetchSrv: AuthFetchService) {
    this.pagesConfig = this.settingsSrv.userConfig['pages'] || {};
  }

  // å­å¨token
  setToken(token: string) {
    this.settingsSrv.resetSettings();
    this.initTemp();
    this.settingsSrv.setToken(token);
    this.getUser();
    this.getMenuAndAcess();
  }

  // è·åç¨æ·ä¿¡æ¯
  getUser() {
    this.authFetchSrv.getUser().subscribe((res) => {
      if (res.status) {
        this.setUser(res.data || {});
      }
    });
  }

  // è·åèåä¿¡æ¯
  getMenuAndAcess() {
    const param = {
      appId: this.pagesConfig['appId'],
    };
    this.authFetchSrv.getMenuAndAcess(param).subscribe((res) => {
      if (res.status) {
        this.storeDatas(res.data);
      }
    });
  }

  initTemp() {
    this.permissionsData = [];
    this.menuData = [];
    this.isGetUserReady = false;
    this.isGetMenuReady = false;
  }

  // å­å¨ç¨æ·ä¿¡æ¯
  setUser(data) {
    this.settingsSrv.setUser(data);
    this.getAllTenantId(data.tenantId);
  }

  // è·åææçç§æ·åè¡¨
  getAllTenantId(str?: string) {
    this.authFetchSrv.getAllTenantId().subscribe((res) => {
      if (res.status) {
        this.setLogo(res.data, str);
      }
    });
  }

  // è®¾ç½®é¡¹ç®åç§°ç­ä¿¡æ¯
  setLogo(data?: any, str?: string) {
    const file = this.settingsSrv.userConfig['env'].serverName.file;
    const themeConfig = this.settingsSrv.userConfig['theme'];
    data.forEach((item) => {
      if (item.tenantId === str) {
        this.logoConfig.logo = themeConfig.logo ? themeConfig.logo : `${file}${API.imgDown}${item.logo}`;
        this.logoConfig.projectName = themeConfig.projectName ? themeConfig.projectName : item.tenantName;
        this.logoConfig.tenantName = item.tenantName;
        // this.settingsSrv.setLogoConfig(this.logoConfig);
        this.settingsSrv.setLayout('logoConfig', this.logoConfig);
      }
    });
    this.isGetUserReady = true;
    this.gotoHome();
  }

  // è½¬æ¢æéåèåæ°æ®
  // ææ¶ä¸æ³å¨ä¸ä¸ªå¾ªç¯éé¢ææ°æ®é½å¤çåºæ¥
  storeDatas(data) {
    this.getAccess(data);
    this.menuData = this.getMenu(data).filter((item) => item.asMenu) || [];
    this.settingsSrv.setPermissions(this.permissionsData);
    // æéä¿¡æ¯æ°å¢modelIds, ææçæéä¿¡æ¯ç ï¼ 1104-EDIT
    this.settingsSrv.setModelIds(this.modelIds);
    this.settingsSrv.setMenu(this.menuData);
    this.isGetMenuReady = true;
    this.gotoHome();
  }

  gotoHome() {
    if (this.isGetMenuReady && this.isGetUserReady) {
      this.isGetMenuReady = this.isGetUserReady = false;
      // ä¼åçº§ï¼
      // 1. redirectUrlæ¯ç»éå¤±è´¥éæ°ç»éåéå®åçurlï¼å®æ¯ç¨æ·æå¼çé¡µé¢
      // 2. loginRedirectUrlæ¯å¼åèå¨é¡¹ç®çapp.configä¸­éç½®çç»éåéå®åçurl
      // 3. HOME_URLæ¯é»è®¤ç»éåéå®åçurl,å®çå¼æ¯`pages/home`
      const url =
        this.settingsSrv.redirectUrl || this.settingsSrv.userConfig.pages.loginRedirectUrl || COMMON_COMFIG.HOME_URL;
      this.router.navigateByUrl(url);
      this.settingsSrv.cleanRedirectUrl();
    }
  }

  /**
   * @desc éå½èåæ å½æ°è·åèåæ°æ®
   */
  getMenu(datas = [], ids?: string[]) {
    // æ°æ®ä¸ºç©º
    if (isEmpty(datas)) {
      return [];
    }
    // idséåï¼èåç¶å­å³ç³»å¤æ­ä¾æ®
    ids = ids || [];
    // å¾ªç¯è½¬æ¢æ°æ®
    datas.map((data, idx) => {
      // è¦å¯¹å¾ªç¯çæ¬å°è¿è¡æ¹åï¼èä¸æ¯åé
      const _data = datas[idx];
      // è¥ä¸æ¯èååè¿å
      if (!_data.asMenu) {
        return;
      }
      // æ°æ®è½¬æ¢
      const { moduleId, moduleName, moduleNameEn, css, action, asMenu, children } = _data;
      _data.ids = ids.concat([moduleId]);
      _data.name = moduleName;
      _data.nameEn = moduleNameEn;
      _data.icon = css;
      _data.url = _data.action = this.handleRouterJump(action);
      _data.param = this.handleUrlParam(action);
      // å»é¤ä¸æ¯èåçå­éï¼å ä¸ºæçæ¯è·¯ç±ä½ä¸æ¯èå
      if (asMenu && children && children.length > 0) {
        _data.children = this.getChildrenMenu(children);
        if (!isEmpty(_data.children)) {
          _data.hasChildren = true;
          this.getMenu(_data.children, _data.ids);
          return;
        }
      }
      // å¦æä»¥ä¸æ¯èåæèå­éä¸ºç©ºï¼å é¤å­é
      delete _data.children;
      _data.hasChildren = false;
    });
    return datas;
  }

  // å¤çè·³è½¬è·¯ç±
  handleRouterJump(url) {
    if (!url) {
      return '';
    }
    return url.split('?')[0].replace('/pcp', '');
  }

  // å¤çèåè·¯å¾ä¸­çåæ°é®é¢
  handleUrlParam(url: string) {
    const obj = {};
    if (!url) {
      return;
    }
    if (url.indexOf('?') !== -1) {
      const arr = url.split('?')[1].split('&');
      arr.forEach((item) => {
        obj[item.split('=')[0]] = item.split('=')[1];
      });
    }
    return obj;
  }

  //  è·åæ¬¡çº§èåæ°æ®
  getChildrenMenu(datas) {
    const menu = [];
    datas.forEach((data) => {
      if (data.asMenu) {
        menu.push(data);
      }
    });
    return menu;
  }

  /**
   * @desc éå½èåæ å½æ°è·åæéæ°æ®
   * @param data  èååæéçæ ç»ææ°æ®
   * @param router é¡µé¢çè·¯ç±
   */
  getAccess(data, router?) {
    if (isEmpty(data)) {
      return;
    }
    const accessArr = [];
    data.forEach((ele) => {
      if (ele.children) {
        this.getAccess(ele.children, this.handleRouterJump(ele.action));
      } else if (!ele.asMenu) {
        const id = ele.moduleId.slice(ele.moduleId.lastIndexOf('-') + 1);
        accessArr.push(id);
        this.modelIds.push(ele.moduleId);
      }
    });
    if (accessArr.length > 0) {
      this.saveAccess(accessArr, router);
    }
  }

  /**
   * @desc æéä¿¡æ¯å­å¨
   * @param data array
   * @param router string
   */
  saveAccess(data, router) {
    if (!router) {
      return;
    }
    const permission = {
      router,
      opreations: data,
    };
    this.permissionsData.push(permission);
  }
}
